const init = () => {
    let hsiIframe = '';
    const scriptElements = document.getElementsByTagName('script');

    for (let i = 0; i < scriptElements.length; i++) {
        const scriptElement = scriptElements[i];
        const src = scriptElement.getAttribute('src');

        if (
            src &&
            src.includes(
                'https://www.highspeedinternet.com/widget/embed-script'
            )
        ) {
            const checkForHsiFrame = setInterval(() => {
                // check for if widget is written to page
                if (document.getElementById('hsi-provider-widget')) {
                    clearInterval(checkForHsiFrame);

                    hsiIframe = document.getElementById('hsi-provider-widget');
                    const urlParams = new URLSearchParams(
                        window.location.search
                    );
                    let hsiScript = hsiIframe.src;

                    // append URL vars to widget src
                    urlParams.forEach((value, key) => {
                        hsiScript = `${hsiScript}&${key}=${value}`;
                    });

                    hsiIframe.src = hsiScript;
                }
            }, 100);
        }
    }
};

export { init };
